import { useUserId } from '~hooks/useUserId';
import { subscriptionApi } from '~services/api/subscription';

export const useSubscriptions = () => {
	const id = useUserId();
	const {
		data: subs = { subscriptions: [] },
		isLoading,
		isSuccess,
	} = subscriptionApi.useGetSubscriptionsQuery({ id });
	const { subscriptions } = subs;

	const activeSubscription = subscriptions.find((s) => {
		const endDate = new Date(s.endDate);
		const now = new Date();
		return endDate > now;
	});

	return {
		isLoading,
		isSuccess,
		hasData: subscriptions.length > 0,
		subscriptions,
		activeSubscription,
	};
};
